const conditionList = {
  bindings: {
  },
  templateUrl: '/modules/pis-tool/condition-list/conditionList.html',
  controller: 'ConditionListController',
};

angular
  .module('pis-tool.module')
  .component('conditionList', conditionList)
  .config(function($stateProvider) {
      $stateProvider.state('pis.workspaces.condition-list', {
          url: '/condition-list',
          views: {
              'pisview@pis': 'conditionList',
          },
      });
  });
